module.exports = __webpack_public_path__ + "static/media/Trailor.b91c080f.mp4";